import { render, staticRenderFns } from "./PointsCouponsPreview.vue?vue&type=template&id=fcfd4b02&scoped=true&"
import script from "./PointsCouponsPreview.vue?vue&type=script&lang=js&"
export * from "./PointsCouponsPreview.vue?vue&type=script&lang=js&"
import style0 from "./PointsCouponsPreview.vue?vue&type=style&index=0&id=fcfd4b02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfd4b02",
  null
  
)

export default component.exports